// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"3618":"9211ef17","4274":"103ba6be","8847":"92e7ea31"}[chunkId] + ".css";
};